import styled from '@emotion/styled';

export const SubHeader = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
`;

export const Header = styled.div`
  ${({ theme }) => theme.media.showAt({ to: 1 })`
    padding-top: 0;
    padding-bottom: ${theme.spacing(2)};
  `}
`;

export const StreetCarouselWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ to: 1 })`
      padding: 0 ${theme.spacing(2)};
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
      padding: 0 ${theme.spacing(4)};
  `}
`;

export const InsightsWrapper = styled.div`
  > div {
    background: none;
  }
`;

export const PricesWrapper = styled.div`
  ${({ theme }) => `
    padding: 0 ${theme.spacing(3)};
  `}
`;

export const ChartWrapper = styled.div`
  ${({ theme }) => `
    margin: ${theme.spacing(7)} 0 ${theme.spacing(8)} 0;
  `};
`;

export const BlogSectionBg = styled.div`
  ${({ theme }) => `
    background: ${theme.colors.neutrals.grey10};
    margin: ${theme.spacing(5)} 0;
    padding: 0 ${theme.spacing(3)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding: 0;
    div.carousel-shadow-root div.view-pager-rail,
    .street__blog-header {
      padding: 0 ${theme.spacing(3)};
    }
  `}
`;
